// extracted by mini-css-extract-plugin
export var createdDate = "_nk-1";
export var divider = "_nk-2";
export var headerDivider = "_nk-3";
export var messagesCard = "_nk-0";
export var messagesContainer = "_nk-6";
export var messagesContainerWrapper = "_nk-4";
export var showLeftPanelButton = "_nk-8";
export var topButtons = "_nk-7";
export var withPadding = "_nk-5";